class NetworkMessage {
    defaults() {
        return {
            unread: true,
        }
    }

    markAsRead() {
        this.unread = false
    }

    isUnread() {
        return this.unread
    }
}

export default NetworkMessage
